
export async function headerSearch(headerSearchTogglers) {
    for (const toggler of headerSearchTogglers) {
        toggler.onclick = (e) => {
            const wrapper = e.target.closest('#headerSearch')
            if (wrapper) {
                wrapper.classList.toggle('open')
                const whisperContent = document.querySelector('.js-whisper-content')
                if (whisperContent) {
                    whisperContent.style.display = 'none'
                }
            }
        }
    }
}
